<template>

</template>

<script type="text/javascript">
    const uuid = "df1de86217444429abe722619dc8303c"
    // const http = "http://121.201.43.187:12002"
    const http = "http://8.134.103.69:13001/api"
    // const http = "/api"
    function HTMLDecode(text) {
      var temp = document.createElement("div");
      temp.innerHTML = text;
      var output = temp.innerText || temp.textContent;
      temp = null;
      return output;
    }
    export default {
        uuid,
        http,
      HTMLDecode
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/global/global.vue